import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'
import OnBoardWhiteLabelPartyKeys from 'src/constants/locale/key/OnBoardWhiteLabelParty'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )

  let errMsgAlphaNumericSpace = translate(
    Namespace.ON_BOARD_WHITE_LABEL_PARTY,
    OnBoardWhiteLabelPartyKeys.Validations.ERROR_MSG_ALPHA_NUMERIC_SPACE
  )

  const regexAlphaNumericSpace = '^[a-zA-Z0-9 ]+$'

  return Yup.object({
    partyId: Yup.string().nullable().required(requiredMessage),
    parentPartyId: Yup.string().nullable().required(requiredMessage),
    requesterName: Yup.string().nullable().matches(regexAlphaNumericSpace, errMsgAlphaNumericSpace).required(requiredMessage),
    declaration1: Yup.string().nullable(),
    declaration2: Yup.string().nullable(),
    declaration3: Yup.string().nullable(),
    declaration4: Yup.string().nullable()
  })
}

export default makeValidationSchema
